import { CameraSchedule, cameraScheduleSchema } from '@sophocles/entities/CameraSchedule/cameraScheduleRecord';
import { mapListToRecords, normalizeList, websocketsHandlerFactory } from '@sophocles/entities/entityUtils';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';

/* Receive Actions */
export const RECEIVE_CAMERA_SCHEDULES = 'RECEIVE_CAMERA_SCHEDULES';
export function receiveCameraSchedules(json) {
  return {
    type: RECEIVE_CAMERA_SCHEDULES,
    cameraSchedules: mapListToRecords(json, CameraSchedule),
  };
}

/* Request Actions */
// starter request
export const REQUEST_CAMERA_SCHEDULE = 'REQUEST_CAMERA_SCHEDULE';
function requestCameraSchedule(cameraSchedule_id) {
  return {
    type: REQUEST_CAMERA_SCHEDULE,
    cameraSchedule_id,
  };
}

/* Fetch Actions */
// starter fetch

export function fetchCameraSchedule(cameraSchedule_id) {
  return dispatch => {
    dispatch(requestCameraSchedule(cameraSchedule_id));
    return apiClient
      .get(`/cameraschedules/${cameraSchedule_id}/`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data, 'cameraSchedules', cameraScheduleSchema))
      .then(json => dispatch(receiveCameraSchedules(json.entities.cameraSchedules)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_CAMERA_SCHEDULE)));
  };
}

/* Socket Delete Helper — kept for handleCameraScheduleSocketActions */
export const DELETE_CAMERA_SCHEDULE = 'DELETE_CAMERA_SCHEDULE';
function sayDeleteCameraSchedule(cameraSchedule_id) {
  return {
    type: DELETE_CAMERA_SCHEDULE,
    cameraSchedule: cameraSchedule_id,
  };
}

const receiver = (dispatch, json) => dispatch(receiveCameraSchedules(json.entities.cameraSchedules));

export const handleCameraScheduleSocketActions = websocketsHandlerFactory(
  receiver,
  sayDeleteCameraSchedule,
  cameraScheduleSchema,
);
